<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "User Update",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
    },
    data() {
        return {
            title: "User Update",
            totalWingband: 0,
            chapters: [],
            user: {
                id: "",
                role: "",
                username: "",
                contact_number: "",
                created_at: "",
                created_by: "",
                chapter_ids: [],
            }
        };
    },
    created() {
        const total = this.$route.query.totalWingband;
        this.totalWingband = total ? parseInt(total, 10) : 0;
    },
    methods: {
        ...mapActions("user", {
            updateUser: "update",
            readUser: "read",
        }),
        async updateAdmin() {
            var pl = {
                id: this.$route.query.id,
                username: this.user.username,
                role: this.user.role,
                contact_number: this.user.contact_number,
                chapter_ids: this.user.chapter_ids,
            }

            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "You want to update this Admin?",
                type: "warning",
                showCancelButton: true,
                icon: "warning",
                padding: "2em",
            }).then((result) => {
                return result.isConfirmed;
            });
            if (confirmed) {

                const res = await this.updateUser(pl);
                console.log(res);
                if (res.message == "User updated succesfully!") {
                    Swal.fire({
                        icon: "success",
                        title: "User Updated Successfully!",
                    });
                    this.goBack();
                } else {
                    var error = res.message;
                    Swal.fire({
                        icon: "error",
                        title: "Failed!",
                        type: "error",
                        text: error,
                    });
                }
            }
        },
        async getDetails() {
            const data = await this.readUser(this.$route.query.id);
            this.user.id = data.data.id;
            this.user.username = data.data.username;
            this.user.contact_number = data.data.contact_number;
            this.user.chapter_ids = data.data.chapters
                ? data.data.chapters.map(c => c.id)
                : [];

            // Map string role from profile to integer for the select
            const roleMap = { admin: '1', viewer: '2', encoder: '3' };
            this.user.role = roleMap[data.data.role] ?? data.data.role;
            this.user.created_at = data.data.created_at ?? "";
            this.user.created_by = data.data.created_by ?? "";
        },
        async populateChapters() {
            const res = await this.$store.dispatch("chapter/getAll", { limit: 200 });
            this.chapters = (res?.data?.data && Array.isArray(res.data.data))
                ? res.data.data
                : (Array.isArray(res?.data) ? res.data : []);
        },
        goBack() {
            this.$router.push({ path: "/user" })
        },
        toggleChapter(id) {
            const idx = this.user.chapter_ids.indexOf(id);
            if (idx === -1) {
                this.user.chapter_ids.push(id);
            } else {
                this.user.chapter_ids.splice(idx, 1);
            }
        },
        selectAllChapters() {
            this.user.chapter_ids = this.chapters.map(c => c.id);
        },
        deselectAllChapters() {
            this.user.chapter_ids = [];
        },
    },
    mounted() {
        this.populateChapters();
        this.getDetails();
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items">
            <button class="btn btn-info text-white" @click="$refreshPage()"><i class='bx bx-refresh'></i> Refresh</button>
        </PageHeader>
        <div class="row">
            <div class="col-lg-12">
                <div class="card mb-2 p-2">
                    <div class="card-body p-2">
                        <div class="grid-2">
                            <h4 class="mb-4 fw-bolder">Update User</h4>
                            <div class="d-flex justify-content-end align-items-start">
                                <button class="btn btn-danger" @click="goBack()">Back</button>
                            </div>
                        </div>
                        <div class="col-md-12 d-flex">
                            <div class="col-10">
                                <div class="grid-2">
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Username</label>
                                        <input class="form-control" type="text" placeholder="Enter username..."
                                            v-model="this.user.username">
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Role</label>
                                        <select class="form-control" v-model="this.user.role">
                                            <option hidden selected disabled>-- Select Role --</option>
                                            <option value="1">Admin</option>
                                            <option value="2">Viewer</option>
                                            <option value="3">Encoder</option>
                                        </select>
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Contact Number</label>
                                        <input class="form-control" type="text" placeholder="Enter contact number..."
                                            v-model="this.user.contact_number">
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Date Registered</label>
                                        <input class="form-control" type="text" disabled
                                            :value="user.created_at ? new Date(user.created_at).toLocaleString() : '-'">
                                    </div>
                                     <div class="disflex custom-border p-1" v-if="this.user.role == 3 || this.user.role == 2">
                                        <label class="filter-label">Chapter</label>
                                        <div class="d-flex flex-column w-100 gap-2">
                                            <div v-if="user.chapter_ids.length > 0" class="d-flex flex-wrap gap-1">
                                                <span
                                                    v-for="id in user.chapter_ids"
                                                    :key="id"
                                                    class="badge bg-primary d-flex align-items-center gap-1"
                                                >
                                                    {{ chapters.find(c => c.id === id)?.chapter || id }}
                                                    <i class="bx bx-x" style="cursor:pointer; font-size:14px;" @click="toggleChapter(id)"></i>
                                                </span>
                                            </div>
                                            <div class="chapter-list-box">
                                            <div
                                                class="chapter-list-item"
                                                @click="user.chapter_ids.length === chapters.length && chapters.length > 0 ? deselectAllChapters() : selectAllChapters()"
                                            >
                                                <input
                                                    type="checkbox"
                                                    :checked="user.chapter_ids.length === chapters.length && chapters.length > 0"
                                                    @click.stop="user.chapter_ids.length === chapters.length && chapters.length > 0 ? deselectAllChapters() : selectAllChapters()"
                                                />
                                                <span class="ms-2 fw-semibold">Select All</span>
                                            </div>
                                            <hr class="my-1">
                                            <div
                                                v-for="c in chapters"
                                                :key="c.id"
                                                class="chapter-list-item"
                                                @click="toggleChapter(c.id)"
                                            >
                                                <input
                                                    type="checkbox"
                                                    :checked="user.chapter_ids.includes(c.id)"
                                                    @click.stop="toggleChapter(c.id)"
                                                />
                                                <span class="ms-2">{{ c.chapter }}</span>
                                            </div>
                                            <div v-if="chapters.length === 0" class="chapter-list-item text-muted">
                                                No chapters available
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="d-flex justify-content-center align-items-center h-100 custom-border">
                                    <button class="btn btn-success py-4 px-5" @click="updateAdmin">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
th,
td {
    width: 75px !important;
    text-align: start;
}

.table> :not(caption)>*>* {
    text-align: center;
    padding: .5rem .1rem .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}

.chapter-list-box {
    width: 100%;
    height: 200px;
    overflow-y: auto;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
}
.chapter-list-item {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.15s;
    user-select: none;
}
.chapter-list-item:hover {
    background-color: #f1f3ff;
}
.chapter-list-item input[type="checkbox"] {
    cursor: pointer;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}
</style>